import React, { useState, useEffect } from "react";
import "./CaseWork.scss";

import {
  slidesData1,
  slidesData2,
  slidesData3,
  slidesData4,
} from "../../data/data";
import { Link } from "react-router-dom";

const CaseWork = () => {
  const [current, setCurrent] = useState(0);
  const [current2, setCurrent2] = useState(0);
  const [current3, setCurrent3] = useState(0);
  const [current4, setCurrent4] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(current === slidesData1.length - 1 ? 0 : current + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, [current]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent2(current2 === slidesData2.length - 1 ? 0 : current2 + 1);
    }, 3000);
    return () => clearInterval(interval);
  }, [current2]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent3(current3 === slidesData2.length - 1 ? 0 : current3 + 1);
    }, 3000);
    return () => clearInterval(interval);
  }, [current3]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent4(current4 === slidesData2.length - 1 ? 0 : current4 + 1);
    }, 3000);
    return () => clearInterval(interval);
  }, [current4]);

  return (
    <section className="section caseWork" id="caseSection">
      <article className="caseWork__container container">
        <div className="caseWork__container--contents">
          <Link
            href="/drapme-project"
            className="caseWork__container--contents-left"
          >
            <div
              className="content-left--img"
              style={{
                backgroundImage: `url(${slidesData1[current]})`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            ></div>

            <div className="content-left--text">
              <h1>Drapme - Chauffeur service platform</h1>
              <p>Mobile App/Website - Product Design</p>
            </div>
          </Link>

          <div className="caseWork__container--contents-right">
            <div
              className="content-right--img"
              style={{
                backgroundImage: `url(${slidesData2[current]})`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            ></div>

            <div className="content-right--text">
              <h3>Transcend Design & Build - Housing and Real Estate</h3>
              <p>Website Design - Branding</p>
            </div>
          </div>

          <div className="caseWork__container--contents-left">
            <div
              className="content-left--img"
              style={{
                backgroundImage: `url(${slidesData3[current]})`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            ></div>

            <div className="content-left--text">
              <h3>Hypedive - Dj and Music</h3>
              <p>Branding</p>
            </div>
          </div>

          <div className="caseWork__container--contents-right">
            <div
              className="content-right--img"
              style={{
                backgroundImage: `url(${slidesData4[current]})`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            ></div>

            <div className="content-right--text">
              <h3>Deewealthdr - Financial Consultancy</h3>
              <p>Website Design - Branding</p>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
};

export default CaseWork;
